<template>

    <section class="c-patient_info">
        <nav class="c-patient_info__nav">
            <h3
                class="c-patient_info__nav-title"
                :class="{ 'c-patient_info__nav-title--active': active === 'patient' }"
                @click="active = 'patient'">
                Dane pacjenta
            </h3>
            <h3
                class="c-patient_info__nav-title"
                :class="{ 'c-patient_info__nav-title--active': active === 'contact-person' }"
                @click="active = 'contact-person'">
                Dane Przedstawiciela Ustawowego
            </h3>
        </nav>
        <table v-if="active === 'patient'" class="c-patient_info__list">
            <tbody>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Imię i Nazwisko:</td>
                <td class="c-patient_info__item-value">{{ patientName }}</td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Data urodzenia:</td>
                <td class="c-patient_info__item-value">{{ patientBornDate || '&mdash;' }}</td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Płeć:</td>
                <td class="c-patient_info__item-value">{{ patientGender || '&mdash;' }}</td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">PESEL:</td>
                <td class="c-patient_info__item-value">{{ patient.pesel || '&mdash;' }}</td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Adres:</td>
                <td class="c-patient_info__item-value" v-html="patientAddress || '&mdash;'"></td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Numer telefonu:</td>
                <td class="c-patient_info__item-value">
                    <a v-if="patient.phone" :href="`tel:${patient.phone}`">{{ patient.phone }}</a>
                    <span v-else>&mdash;</span>
                </td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Email:</td>
                <td class="c-patient_info__item-value">
                    <a v-if="patient.email" :href="`mailto:${patient.email}`">{{ patient.email || '&mdash;' }}</a>
                    <span v-else>&mdash;</span>
                </td>
            </tr>
            </tbody>
        </table>
        <table v-if="active === 'contact-person'" class="c-patient_info__list">
            <tbody>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Imię i Nazwisko:</td>
                <td class="c-patient_info__item-value">{{ contactPersonName }}</td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Adres:</td>
                <td class="c-patient_info__item-value" v-html="contactPersonAddress || '&mdash;'"></td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Numer telefonu:</td>
                <td class="c-patient_info__item-value">
                    <a v-if="patient.contact_person_phone"
                       :href="`tel:${patient.contact_person_phone}`">{{ patient.contact_person_phone }}</a>
                    <span v-else>&mdash;</span>
                </td>
            </tr>
            <tr class="c-patient_info__item">
                <td class="c-patient_info__item-label">Email:</td>
                <td class="c-patient_info__item-value">
                    <a v-if="patient.contact_person_email"
                       :href="`mailto:${patient.contact_person_email}`">{{ patient.contact_person_email }}</a>
                    <span v-else>&mdash;</span>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="c-patient_info__actions">
            <v-btn
                type="red-white"
                @click="$refs.patientRemoveModal.$emit('open', patient.id)">
                Usuń pacjenta
            </v-btn>
            <v-btn
                type="green"
                :to="{ name: 'PatientEdit', params: { id : patient.id } }">
                Edytuj
            </v-btn>
        </div>

        <patient-remove-modal
            ref="patientRemoveModal"
            @success="$router.push({ name: 'Patients' })">
        </patient-remove-modal>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import PatientRemoveModal from 'Components/Patient/PatientRemoveModal'
import VBtn from 'Components/VBtn'
import moment from 'moment'

export default {

    name: 'PatientInfo',

    data() {
        return {
            active: 'patient'
        }
    },

    computed: {
        ...mapGetters('patient', ['patient']),
        patientName() {
            return this.patient.first_name + ' ' + this.patient.last_name
        },
        patientBornDate() {
            if (this.patient.born_date)
                return moment(this.patient.born_date).format('DD-MM-YYYY')
            return null
        },
        patientGender() {
            if (this.patient.gender)
                return (this.patient.gender === 'male') ? 'Mężczyzna' : 'Kobieta'
            return null
        },
        contactPersonName(patient) {
            return (this.patient.contact_person_first_name || '') + ' ' + (this.patient.contact_person_last_name || '')
        },
        contactPersonAddress() {
            let address = ''

            if (this.patient.contact_person_address_street)
                address += this.patient.contact_person_address_street + '<br>'
            if (this.patient.contact_person_address_postcode)
                address += this.patient.contact_person_address_postcode
            if (this.patient.contact_person_address_postcode && this.patient.contact_person_address_city)
                address += ', '
            if (this.patient.contact_person_address_city)
                address += this.patient.contact_person_address_city

            return address
        },

        patientAddress() {
            let address = ''

            if (this.patient.address_street)
                address += this.patient.address_street + '<br>'
            if (this.patient.address_postcode)
                address += this.patient.address_postcode
            if (this.patient.address_postcode && this.patient.address_city)
                address += ', '
            if (this.patient.address_city)
                address += this.patient.address_city

            return address
        },
    },

    methods: {},

    components: {
        PatientRemoveModal,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-patient_info {
    &__nav {
        margin-bottom: 3rem;
        min-height: 2rem;

        &-title {
            display: inline-block;
            margin: 0;
            margin-right: 0.7rem;
            cursor: pointer;
            color: $c-secondary;
            font-size: .9rem;

            &--active {
                font-size: 1.2rem;
                color: $c-third;
            }
        }
    }
    &__list {
        width: 100%;
        margin-bottom: 3rem;
        border-collapse: separate;
        border-spacing: 0 0.5rem;
    }
    &__item {
        &-label {
            white-space: nowrap;
        }
        &-value {
            color: $c-third;
            text-align: right;
        }
    }
    &__actions {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
}

</style>
